export default function Pricing() {
  const packages = [
    {
      name: 'Essential',
      price: '65',
      popular: false,
      features: [
        'Classic Haircut',
        'Hair Wash & Dry',
        'Basic Styling',
        'Neck Trim',
        'Premium Product Application '
      ]
    },
    {
      name: 'Premium',
      price: '85',
      popular: true,
      features: [
        'Premium Haircut',
        'Beard Trim & Shape',
        'Hot Towel Shave',
        'Scalp Massage',
        'Premium Styling Products',
        'Complimentary Beverage'
      ]
    },
    {
      name: 'Deluxe',
      price: '120',
      popular: false,
      features: [
        'Signature Haircut',
        'Full Beard Service',
        'Luxury Hot Towel Shave',
        'Facial Treatment',
        'Extended Scalp Massage',
        'Premium Product Application',
        'Complimentary Beverage',
        'Priority Booking'
      ]
    }
  ];

  return (
    <section id="pricing" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">Pricing Packages</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the perfect package that suits your grooming needs and budget
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {packages.map((pkg, index) => (
            <div 
              key={index}
              className={`relative bg-white rounded-3xl p-8 ${
                pkg.popular 
                  ? 'shadow-2xl transform scale-105 border-4 border-amber-500' 
                  : 'shadow-lg hover:shadow-xl'
              } transition-all duration-300 cursor-pointer`}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-amber-500 text-black px-6 py-2 rounded-full text-sm font-bold whitespace-nowrap">
                    MOST POPULAR
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-black mb-4">{pkg.name}</h3>
                <div className="flex items-baseline justify-center mb-2">
                  <span className="text-5xl font-bold text-black">${pkg.price}</span>
                  <span className="text-gray-500 ml-2">/visit</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {pkg.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-check-line text-amber-500 text-xl mr-3 flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                    <span className="text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>

              <a 
                href="https://book.squareup.com/appointments/87v5f18dxg1ebp/location/LBKWXNEF1FVM4/services"
                target="_blank"
                rel="noopener noreferrer"
                className={`w-full py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer block text-center ${
                  pkg.popular
                    ? 'bg-amber-500 text-black hover:bg-amber-400'
                    : 'bg-black text-white hover:bg-gray-800'
                }`}
              >
                Book Now
              </a>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 text-lg mb-4">
            <strong>Individual Services Also Available</strong>
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div className="bg-white p-6 rounded-xl shadow">
              <div className="text-2xl font-bold text-amber-500 mb-2">$50</div>
              <div className="text-gray-600">Haircut Only</div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <div className="text-2xl font-bold text-amber-500 mb-2">$30</div>
              <div className="text-gray-600">Beard Trim</div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <div className="text-2xl font-bold text-amber-500 mb-2">$40</div>
              <div className="text-gray-600">Hot Shave</div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <div className="text-2xl font-bold text-amber-500 mb-2">$40</div>
              <div className="text-gray-600">Kids Cut</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
